import React, { createContext, useContext, useMemo } from 'react';
import { useReportQueries } from '../hooks/useReportQueries';
import {
  catalogFieldsFromQueries,
  mergeQueryFirstRows,
  resultForWidget,
  widgetUsesReportQueries,
} from '../utils/reportQueries';

const ReportDataContext = createContext({
  queries: [],
  resultsById: {},
  fields: [],
  mergedRow: {},
  loading: false,
  error: null,
  dataForWidget: () => ({ columns: [], rows: [] }),
  usesShared: () => false,
});

export function ReportDataProvider({ report, period, children }) {
  const { queries, resultsById, loading, error } = useReportQueries(report, period, true);
  const value = useMemo(() => {
    const fields = catalogFieldsFromQueries(queries, resultsById);
    const mergedRow = mergeQueryFirstRows(resultsById);
    return {
      queries,
      resultsById,
      fields,
      mergedRow,
      loading,
      error,
      dataForWidget: (widget) => resultForWidget(widget, resultsById, queries),
      usesShared: (widget) => widgetUsesReportQueries(widget),
    };
  }, [queries, resultsById, loading, error]);

  return (
    <ReportDataContext.Provider value={value}>
      {children}
    </ReportDataContext.Provider>
  );
}

export function useReportData() {
  return useContext(ReportDataContext);
}
